// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wWswrfLzx49EukeodjfA {
  height: 500px;
  display: flex;
  flex-direction: column;
}
.oq1BxZDIctK9ZTA_KaXa {
  flex: 1;
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/Header/Simulation/Workbook/ManualInputs/styles.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AAAF;AAGA;EACE,OAAA;EACA,kBAAA;AADF","sourcesContent":["\n.container {\n  height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  flex: 1;\n  overflow-y: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `wWswrfLzx49EukeodjfA`,
	"content": `oq1BxZDIctK9ZTA_KaXa`
};
export default ___CSS_LOADER_EXPORT___;
